import resolveColor from '../../resolvers/ColorResolver';
export default function resolveBackgroundColor(theme, screenWidth, backgroundColorSupport) {
    var result = {};
    if (backgroundColorSupport.backgroundColor !== undefined) {
        result.backgroundColor = resolveColor(theme, screenWidth, backgroundColorSupport.backgroundColor);
    }
    return result;
}
//# sourceMappingURL=BackgroundColorResolver.js.map